import { Box } from '@zillow/constellation-10';

type Props = {
  children: JSX.Element;
};

export default function SkeletonContainer({ children }: Props): JSX.Element {
  return (
    <Box aria-label="loading" role="status" css={{ pointerEvents: 'none' }}>
      {children}
    </Box>
  );
}
